














import { Component, Vue, Prop } from 'vue-property-decorator';
import { LabelModule } from '@/store/modules/label';

@Component
export default class LabelItem extends Vue {
  @Prop({required: true}) private label!: ILabel.IModel.ILabelClass;
  private editLabel() {
    LabelModule.ToggleLabelModalVisible();
    LabelModule.InitLabelModal(this.label);
  }
  private delLabel() {
    LabelModule.DeleteLabel(this.label.id).then((res) => {
      this.$message.success(res);
    }).catch((err) => {
      this.$message.warning(err);
    });
  }
}
